'use strict';

var EmblaCarousel = require('embla-carousel');
var slickConfigs = require('org/config/slickConfigs');
var emblaUtil = require('org/util/emblaCarousel');

/**
 * Add Pixel click cvent to the HTML container
 * @param {string} container - HTML container
 * @returns {Object} -contayner with click events
 */
function addPixelClickEvent(container) {
    return $(container).on('click', '.image-container', function () {
        var pid = $(this).closest('.product').data('pid').split('-')[0];

        var $widget = $(this).closest('.recommends-widget');
        var widgetData = {
            wrid: $widget.data('wrid'),
            wid: $widget.data('widget-id'),
            wty: $widget.data('wty'),
            item_id: pid
        };
        if (Window.BrTrk) {
            Window.BrTrk.getTracker().logEvent('widget', 'widget-click', widgetData, true);
        }
    });
}

var CAROUSEL_SELECTOR = '.product-suggestions-carousel, .added-modal-products-carousel, .home-einstein-carousel';

/**
 * Read carousel placement set on the slot container in ISML (data-carousel-context).
 * @param {jQuery} $container - Bloomreach widget container
 * @returns {string} carousel context key
 */
function resolveCarouselContext($container) {
    return $container.data('carouselContext') || 'suggestions';
}

/**
 * Resolve slick config for a Bloomreach recommendation container.
 * Mirrors org/components/carousels.js einsteinSupportedCarousels + addedModalProductsCarousel.
 * @param {jQuery} $container - Bloomreach widget container
 * @param {jQuery} $carousel - Rendered carousel element
 * @returns {Object} slick configuration
 */
function getRecommendationSlickConfig($container, $carousel) {
    if ($carousel.hasClass('added-modal-products-carousel') || resolveCarouselContext($container) === 'addedModal') {
        return slickConfigs.addedModal;
    }

    if ($container.closest('.pdp-top-page-carousel-wrapper').length > 0) {
        return slickConfigs.suggestionsTopPage;
    }

    return slickConfigs.suggestions;
}

/**
 * Init Embla on a suggestion carousel element
 * @param {HTMLElement} rootNode - The carousel root element with .embla-slider
 * @param {jQuery} $container - Bloomreach widget container
 * @param {jQuery} $carousel - Rendered carousel element
 */
function initSuggestionEmblaCarousel(rootNode, $container, $carousel) {
    emblaUtil.initResponsiveEmblaCarousel(rootNode, EmblaCarousel, function () {
        var slickConfig = getRecommendationSlickConfig($container, $carousel);
        return {
            slidesToShow: emblaUtil.getSlickOption(slickConfig, 'slidesToShow'),
            slidesToScroll: emblaUtil.getSlickOption(slickConfig, 'slidesToScroll') || 1
        };
    });
}

module.exports = {
    addToCartEvent: function () {
        $('body').on('product:addToCartFromRecommendation', function (e, data) {
            const widgetId = data.refWidgetId;
            const $widgetEl = $('#br_includeHtml_' + widgetId).find('.recommends-widget');
            var widgetAtcData = {};
            widgetAtcData.wrid = $widgetEl.data('wrid');
            widgetAtcData.wid = widgetId;
            widgetAtcData.wty = $widgetEl.data('wty');
            widgetAtcData.item_id = data.itemId;
            widgetAtcData.sku = data.sku;

            if (Window.BrTrk) {
                // eslint-disable-next-line no-undef
                BrTrk.getTracker().logEvent('cart', 'widget-add', widgetAtcData);
            }
        });
    },
    updateWidget: function () {
        $('body').on('widget:update', function (e, data) {
            var $widgetContainers = (data && data.element) ? $(data.element) : $('.recommends-container');
            $widgetContainers.each(function () {
                var $container = $(this);
                var $widget = $container.find('.recommends-widget');
                var widgetViewData = {
                    wrid: $widget.data('wrid'),
                    wid: $widget.data('widget-id'),
                    wty: $widget.data('wty')
                };

                var url = $container.data('url');
                var queryArr = [];

                $.each($widget.data(), function (key, value) {
                    var val = (data && data[key] !== null && data[key] !== undefined) ? data[key] : value;
                    queryArr.push(key + '=' + val);
                });

                // Add style_number from product page data attribute if available
                var $productDetails = $('#pdpProductDetails');
                if ($productDetails.length > 0) {
                    var styleNumber = $productDetails.data('style-number');
                    if (styleNumber) {
                        queryArr.push('style_number=' + encodeURIComponent(styleNumber));
                    }
                }

                queryArr.push('carousel_context=' + encodeURIComponent(resolveCarouselContext($container)));

                var carouselTitle = $container.data('carouselTitle');
                if (carouselTitle) {
                    queryArr.push('carousel_title=' + encodeURIComponent(carouselTitle));
                }

                if (queryArr.length > 0) {
                    var separator = url.indexOf('?') > -1 ? '&' : '?';
                    url += separator + queryArr.join('&');
                }

                $widget.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: function (response) {
                        var widgetContent = addPixelClickEvent(response);
                        const $widgetEl = widgetContent.closest('.recommends-widget');
                        widgetViewData.wrid = $widgetEl.data('wrid');
                        widgetViewData.wty = $widgetEl.data('wty');
                        widgetViewData.wid = $widgetEl.data('widget-id');

                        $container.empty().append(widgetContent);
                        const $carousel = $container.find(CAROUSEL_SELECTOR);
                        if ($carousel.length > 0 && $carousel.find('div.product').length > 1) {
                            if ($carousel.hasClass('embla-slider')) {
                                initSuggestionEmblaCarousel($carousel[0], $container, $carousel);
                            } else {
                                $carousel.not('.slick-initialized').slick(getRecommendationSlickConfig($container, $carousel));
                            }
                        }
                        $.spinner().stop();
                        if (Window.BrTrk) {
                            Window.BrTrk.getTracker().logEvent('widget', 'widget-view', widgetViewData);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        });
    },
    pixelViewPortEvent: function () {
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries, obs) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var element = entry.target;
                        $(element).data('trigered', true);
                        $('body').trigger('widget:update', { element: element });
                        obs.unobserve(element);
                    }
                });
            });

            $('.recommends-container').each(function () {
                if (!$(this).data('trigered')) {
                    observer.observe(this);
                }
            });
        }
    }
};
